import { Component, ViewChild } from '@angular/core';
import { AppService } from '../../services/services';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { EncryptionService } from 'src/app/services/encryption.service';
import { Modal } from 'bootstrap';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';
import { FileUploadComponent } from 'src/app/common/file-upload/file-upload.component';

@Component({
  selector: 'nri-app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent {
  @ViewChild(FileUploadComponent) fileUploadComp!: FileUploadComponent;
  addressDOc: string = '';
  cityKeyword = 'City';
  cityList: any = [];
  cityName: any;
  cityNameError: boolean = false;
  communicationAddress: boolean = false;
  addressForm = this.formBuilder.group({
    'AddressLine1': ['', [Validators.required, Validators.minLength(5)]],
    'AddressLine2': ['', [Validators.required, Validators.minLength(5)]],
    'AddressLine3': ['', [Validators.required, Validators.minLength(5)]],
    'City': ['', Validators.required],
    'Country': ['India', Validators.required],
    'DocType': [null as any, Validators.required],
    'PinCode': ['', Validators.required],
    'State': ['', Validators.required],
    // 'DocNumber': ['', Validators.required]
  });
  countryList: any;
  countryName: string = '';
  docTypeList: any = '';
  docError: boolean = false;
  erefNo: string = '';
  immigration: boolean = false;
  imgStampImgempty: boolean = false;
  imgStampUpdt: boolean = false;
  indianHolder: boolean = true;
  indianAddress: string = 'Y';
  pioociadr: string = 'N';
  pinCode: any;
  pincodeList: any = [];
  pinKeyword = 'Pincode';
  perAdrImgempty: boolean = false;
  perAdrImgempty1: boolean = false;
  perAdrUpdt: boolean = false;
  perAdrUpdt1: boolean = false;
  sameAddress: string = 'N';
  source: any = '';
  stateName: any;
  pinCodeError: boolean = false;
  reStatus: any;
  fAdd: any;
  address: boolean = false;
  nri: boolean = false;
  pio: boolean;
  pioImageFront: any;
  pioImageBack: any;
  sameAsPio: boolean = false;
  imageChange: boolean = false;
  previousDocs: boolean = false;
  foAdrUpdt: boolean = false;
  foAdrImgempty: boolean = false;
  docName: string = '';
  mariner: boolean;
  pincodeErrorMsg: boolean = false;
  stateErrorMsg: boolean = false;
  piooci: any;
  piocard: boolean;
  pioletter: string = '';
  changeIDs: string | number;
  changeDoc: boolean = false;
  passportNationality: boolean = false;
  @ViewChild('errorComp') errorComp: ErrorModalComponent;
  stateList: Array<any> = [];
  mandatory: boolean = true;
  digi: boolean = false;
  MobileLinkAadhar: string = "";
  permanentoption: boolean = false;
  digio_doc_id: string = '';
  DigiStatus: string = '';
  DigiMessage: string = '';
  pan: string = '';
  DigiOptionval: string = '';
  NRO: string = '';
  ClientName: string = '';
  search: any = {};
  options2: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };
  defaultMonth: IMyDefaultMonth;
  lastArrivalDt: any;
  arrivalDateError: boolean = false;
  lastArrivalDate: any = '';
  expiryDateError: boolean = false;
  prevsixMonthDate: any;
  sixMonthDate: any;
  ExpiryDate: any;
  datesection = false;
  completestage: boolean = false;
  docNumberValue = '';
  constructor(private router: Router, private loader: NgxUiLoaderService, private toastr: ToastrService, private http: EncryptionService, public _http: AppService, public formBuilder: FormBuilder) {
    this._http.getRefNum().subscribe(data => {
      this.erefNo = data;
    });
    this._http.getStatus().subscribe(data => {
      if (data.ReStatus === 'FN' && data.Mariner === false) {
        this.indianHolder = false;
        this.nri = false;
        this.mariner = false;
      } else if (data.ReStatus === 'N' && data.Mariner === false) {
        this.indianHolder = true;
        this.nri = true;
        this.mariner = false;
      }
      else if (data.Mariner === true && data.ReStatus === 'N') {
        this.indianHolder = true;
        this.nri = true;
        this.mariner = true;
      }
      if (data.Stamp) {
        this.immigration = true;
      }
    });
    this.overallStatus();
    this._http.getPermanentAddress().subscribe((data) => {
      this.fAdd = data.foreigmAddress;
      if (this.fAdd === true) {
        this.address = true;
        this.communicationAddress = false;
      } else {
        this.address = true;
        this.communicationAddress = true;
      }
    })
    this._http.getImageURLFront().subscribe(data => {
      this.pioImageFront = data.frontimage;
    })

    this._http.getImageURLBack().subscribe(data => {
      this.pioImageBack = data.backimage;
    })

    this._http.getPio().subscribe((data: any) => {
      if (data.PIOOCI === true) {
        this.sameAsPio = true;
      } else {
        this.sameAsPio = false;
      }

    })
  }

  ngOnInit() {
    this._http.getMasters().subscribe(data => {
      if (data && data.DocumentTypeList) {
        this.docTypeList = data.DocumentTypeList;
        this._http.getStatus().subscribe(d => {
          if (this.indianHolder) {
            this.docTypeList = data.DocumentTypeList.filter((e: any) => {
              return e.DocumentCategory === 2;
            })
            let order = ['Aadhar', 'Passport', 'Driving License', 'Voter ID'];
            this.docTypeList.sort((a: any, b: any) => order.indexOf(a.Name) - order.indexOf(b.Name));
          } else {
            this.docTypeList = data.DocumentTypeList.filter((e: any) => {
              return e.DocumentCategory === 1;
            })
          }
          if (d.ReStatus === 'FN') {
            this.reStatus = d.ReStatus;
          } else {
            this.reStatus = d.ReStatus;
          }
        })
      }
      if (data && data.stateList) {
        this.stateList = data.stateList;
      }
      this._http.getStatus().subscribe(d => {
        if (!this.indianHolder) {
          if (d.PIOOCIType === 'P') {
            this.pio = true;
            this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 2); // Remove OCI Card
          } else if (d.PIOOCIType === 'O') {
            this.pio = false;
            this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 3); // Remove PIO Card
          }
        }
      })
    });
      const today = new Date();
    const disableDate = new Date();
    disableDate.setDate(today.getDate() + 60);
    this.options2 = {
      dateFormat: 'dd/mm/yyyy',
      showTodayBtn: false,
      disableUntil: { 
        year: disableDate.getFullYear(), 
        month: disableDate.getMonth() + 1, 
        day: disableDate.getDate()  
      }
    }
    this.defaultMonth = {
      defMonth: `${disableDate.getMonth() + 1}/${disableDate.getFullYear()}`
    };
    let month:any = this.defaultMonth.defMonth.split('/');
    if (Number(month[0]) < 10) {
      month = '0' + month[0];
    }
    this.defaultMonth.defMonth = `${month}/${disableDate.getFullYear()}`;
    this.countryList = this._http.countryList.filter((e:any)=>{
      return e.Name !== 'India';
    });
    if (sessionStorage.getItem('searchParams')) {
      this.search = JSON.parse(sessionStorage.getItem('searchParams') || '{}');
    }
    if (Object.keys(this.search).length > 0) {
      this.digio_doc_id = this.search['token'];
      this.DigiStatus = this.search['success'];
      // this.DigiMessage = this.search['message'];
    }
    this.countryList = this._http.countryList.filter((e: any) => {
      return e.Name.toLowerCase() === "india";
    })
    if (this.digio_doc_id && this.DigiStatus === 'y') {
      this.digilockerFetch();
    }
    if (sessionStorage.getItem('NRO')) {
      this.NRO = sessionStorage.getItem('NRO') || '';
    }
    this.getAddressInfo();
    this._http.scroll();
  }

  getOCR(event: any) {
    console.log("ocrRead", event)
    let ocrFront;
    if (event.data.BindingdataFront) {
      ocrFront = event.data.BindingdataFront;
    } else {
      ocrFront = event.data.BindingdataBack
    }

    if (ocrFront) {
      let state = ocrFront.State ? ocrFront.State : "";
      let pincode = ocrFront.Pincode ? ocrFront.Pincode : "";
      let address1 = ocrFront.Addressline1 ? ocrFront.Addressline1 : "";
      let address2 = ocrFront.Addressline2 ? ocrFront.Addressline2 : "";
      let address3 = ocrFront.Addressline3 ? ocrFront.Addressline3 : "";
      let city = ocrFront.District ? ocrFront.District : "";
      this.addressForm.patchValue({
        State: state,
        PinCode: pincode,
        AddressLine1: address1,
        AddressLine2: address2,
        AddressLine3: address3,
        City: city
      })
    }
  }

  overallStatus() {
    let url = 'DIY/DIYOverallStatus';
    let checkSum = this.erefNo;
    let params = {
      'ReferenceNumber': this.erefNo,
    }
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        let val = this.http.decryptUsingAES256(data.OutPut)
        if (val && val.IsSuccess) {
          let item = val.overallLists;
          this.piocard = val.PIOOCI;
          this.pioletter = val.PIOOCIType;
          this.fAdd = val.IsForeignComAddress;
          this.fAdd = val.PValidation;
          this.pan = val.PanNumber;
          this.NRO = val.NRO;
          this.ClientName = val.ClientName;
          if (val.digilocker === "Y") {
            sessionStorage.setItem("digilocker", val.digilocker)
            this.addressForm.disable();
            this.digi = true;
          }
          if (item[5].DIY === 'Y') {
            this.completestage = true;
          }
          if (val.PIOOCIType === 'F' && val.PValidation === 'N') {
            this.mandatory = false;
          }
        }

      },
      error: _error => {
        this.loader.stop();
        this.errorComp.ModalShow(_error.error.Message);
        // this.toastr.error(_error.error.Message)
      }
    })
  }

  radioCheck() {
    if (this.sameAddress !== 'Y') {
      this.addressForm.controls.Country.setValue('India');
    }
  }

  getAddressInfo() {
    let url = "DIY/DIYGetPerAddr";
    const checkSum = this.erefNo;
    let params = {
      "ReferenceNumber": this.erefNo
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        let val = this.http.decryptUsingAES256(data.OutPut);
        if (val.PassportNationality && val.PassportNationality.toLowerCase() !== "india") {
          this.passportNationality = true;
        }
         if (val.ProofId === 1033 || val.ProofId === 10) {
            this.datesection = true;
          }
          if (val.PEXDATE) {
            let a = val.PEXDATE.split(' ');
            let d = a[0].split('/');
            this.lastArrivalDate = a[0];
            this.lastArrivalDt = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          }
        if (val && val.IsSuccess) {
          if (val.IsIndianPassport) {
            this.indianHolder = true;
            if (val.IsPassport) {
              this.sameAddress = 'Y';
            } else {
              this.sameAddress = 'N';
            }
          } else {
            // this.indianHolder = false;
            if (val.StageSkip) {
              this.sameAddress = 'Y'
              if (val.SameAsPIOOCI) {
                this.pioociadr = 'Y';
                this.indianAddress = 'Y';
                // this.imageChange = true;
              } else {
                this.indianAddress = 'N';
                // this.imageChange = false;
              }
            } else {
              this.sameAddress = 'N'
              this.pioociadr = 'N';
              this.indianAddress = 'Y';
            }
          }




          this.communicationAddress = val.CommunicationAddress;
          this.addressForm.patchValue({
            'AddressLine1': val.AddressLine1,
            'AddressLine2': val.AddressLine2,
            'AddressLine3': val.AddressLine3,
            'City': val.City.trim(),
            'State': val.State,
            'PinCode': val.Pincode,
            'Country': val.Country,
            // 'DocNumber': val.PER_ADD_REF
          });
          this.docNumberValue =val.PER_ADD_REF
          this.pinCode = val.Pincode;
          this.cityName = val.City;
          if (val.MobileLinkAadhar && this.NRO === 'Y') {
            this.permanentoption = true;
            this.MobileLinkAadhar = val.MobileLinkAadhar;
            this.DigiOptionval = val.MobileLinkAadhar;
          }
         
          this.docTypeCheck(val.ProofId, false);
          if (val.ProofId) {
            this.addressForm.controls.DocType.setValue(val.ProofId)
          }

        }
      }, error: _error => {
        this.loader.stop();
        this.errorComp.ModalShow(_error.error.Message);
        // this.toastr.error(_error.error.Message);
      }
    })
  }

  public noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length ? null : { 'whitespace': true };
  }

  onInputChange(event: any) {
    const pattern = new RegExp('^[a-zA-Z0-9.,/ \b]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!pattern.test(key) && event.charCode !== 0) {
      event.preventDefault();
      return;
    }
  }

  onInputChanged(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    const allowedCharacters = /^[a-zA-Z0-9.,/\s]+$/;

    // Remove disallowed characters from the input value
    const sanitizedValue = currentValue.split('').filter(char => allowedCharacters.test(char)).join('');

    // Set the sanitized value back to the input field
    inputElement.value = sanitizedValue;
  }




  alphabetOnly(event: any, name: string) {
    if (name === 'State') {
      const regex = /[^a-zA-Z ]/g;
      const input = event.target.value;
      event.target.value = input.replace(regex, '');
      this.addressForm.controls[name].setValue(event.target.value);
    }
    if (name === 'City') {
      const regex = /[^a-zA-Z ]/g;
      const input = event;
      event = input.replace(regex, '');
      this.cityName = event;
    }
  }

  numericOnly(event: any) {
    const regex = /[^0-9]/g;
    const input = event;
    event = input.replace(regex, '');
    if (event.length > 6) {
      event = event.substring(0, event.length - 1);
    }
    this.pinCode = event;
    if (this.pinCode) {
      this.addressForm.controls.State.setValue('');
      this.stateName = '';
      this.getPinCodeVal();
    }
  }

  spaceValidation(event: any, name: string) {
    const input = event.target.value;
    event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
    if (name === 'AddressLine1' || name === 'AddressLine2' || name === 'AddressLine3' || name === 'City' || name === 'State' || name === 'PinCode') {
      this.addressForm.controls[name].setValue(event.target.value);
    }
  }

  clear() {
    this.addressForm.controls.City.setValue('');
    this.addressForm.controls.State.setValue('');
  }

  cityclear() {
    this.addressForm.controls.City.setValue('');
  }

  getPinCodeVal() {
    const path = 'DIY/GetPincode?Pincode=' + this.pinCode;
    this.pinCodeError = false;
    this._http.httpGet(path).subscribe({
      next: (data: any) => {
        if (data && data.Pincode) {
          this.pincodeList = data.Pincode;
          if (this.pinCode.length === 6) {
            this.selectPinEvent(this.pincodeList[0])
          }
        } else {
          if (this.pinCode.length === 6) {
            this.pinCodeError = true;
          }
        }
      }
    })
  }

  selectPinEvent(item: any) {
    this.pinCode = item.Pincode;
    this.addressForm.controls.PinCode.setValue(item.Pincode);
    this.addressForm.controls.State.setValue(item.State)
    this.stateName = item.State;
    const path = 'DIY/GetCity?StateId=' + item.StateId;
    this.pinCodeError = false;
    this._http.httpGet(path).subscribe({
      next: (data: any) => {
        if (data && data.City) {
          this.cityList = data.City;
        }
      }
    })
  }

  selectCityEvent(city: any) {
    this.cityNameError = false;
    this.addressForm.controls.City.setValue(this.cityName)
  }

  disableInput() {
    setTimeout(() => {
      this.addressForm.controls.State.setValue(this.stateName)
    }, 100)
  }


  restrictEnter(args: any) {
    if (args.key === "Enter" && args.keyCode == 13)
      args.preventDefault();
  }

  getCountryName() {
    let a: any = this.addressForm.controls.Country.value;
    this.countryName = a;
    /* let c = parseInt(a);
     let name = this.countryList.filter((e:any)=>{
       return e.Id === c;
     })
     this.countryName = name[0].Name;*/

    if (this.countryName === 'America' || this.countryName === 'Canada') {
      this.immigration = true;
    }
  }

  typeError(event: boolean) {
    this.docError = event;
    console.log(event, "event 381");

  }

  getID(id: any) {
    // if((id === 2 || id === "2") || (id === 3 || id === "3")){
    //   this.sameAsPio =  true;
    // }else{
    //   this.sameAsPio =  false;
    // }
    // console.log(id,"aaaaaaaaaaa  id");

    this.addressForm.controls.DocType.setValue(id);
  }

  imageURL(event: any) {
    if (event.url && event.name === 'PerAddr') {
      this.perAdrUpdt = true;
      this.perAdrImgempty = false;
      this.changeDoc = false;
    }
    if (event.url && event.name === 'PerAddr1') {
      this.perAdrUpdt1 = true;
      this.perAdrImgempty1 = false;
      this.changeDoc = false;
    }
    if (event.name === 'PIOOCI' || event.name === 'PIOOCIBACK') {
      this.perAdrUpdt = true;
      this.perAdrImgempty = false;
      this.perAdrUpdt1 = true;
      this.perAdrImgempty1 = false;
    }
    else if (event.url && event.name === 'Stamp') {
      this.imgStampUpdt = true;
      this.imgStampImgempty = false;
    }
    if (!event.url && event.name === 'PerAddr') {
      this.perAdrUpdt = false;
    }
    if (!event.url && event.name === 'PerAddr1') {
      this.perAdrUpdt1 = false;
    }
  }


  checkType(event: any) {
    this.docTypeCheck(event.target.value, true);
    if (!this.perAdrImgempty && (event.target.value !== 1033 || event.target.value !== "1033")) {
      this.changeDoc = true;
    }
  }

  goTo() {
    this.addressForm.controls.DocType.setValue("");
  }



  docTypeCheck(e: any, action: boolean) {
    let b = parseInt(e);
    let a = this.docTypeList.filter((e: any) => {
      return e.DocumentTypeId === b;
    })
    if (a[0].DocumentTypeId === 1033 || a[0].DocumentTypeId === 10) {
      this.datesection = true;
    }
    if (a.length >= 1) {
      if ((a[0].Name === 'Passport' || (a[0].OCI && this.reStatus === 'FN')) && !this.passportNationality) {
        this.previousDocs = true;
        this.foAdrUpdt = true;
        this.foAdrImgempty = false;
        if (action) this.getPassportInfo();
      }
      else if (a[0].Name === 'Passport' && this.passportNationality) {
        const element = document.getElementById('redirect') as HTMLElement;
        const theModal = new Modal(element, { backdrop: 'static', keyboard: false });
        theModal.show();
      }
      else {
        if (action) {
          this.previousDocs = false;
          this.changeIDs = b;
        }
      }
    }

    if (a.length !== 0) {
      this.docName = a[0].Name;
    }
  }
  getPassportInfo() {
    this.loader.start();
    const checksum = this.erefNo;
    const path = `DIY/DIYGetPassportOCR`;
    let params = {
      ReferenceNumber: this.erefNo
    }
    this._http.httpPost(path, params, checksum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        let decryptData = this.http.decryptUsingAES256(data.OutPut);
        if (decryptData && decryptData.IsSuccess) {
          this.addressForm.patchValue({
            AddressLine1: decryptData.AddressLine1 ? decryptData.AddressLine1 : this.addressForm.controls.AddressLine1.value,
            AddressLine2: decryptData.AddressLine2 ? decryptData.AddressLine2 : this.addressForm.controls.AddressLine2.value,
            AddressLine3: decryptData.AddressLine3 ? decryptData.AddressLine3 : this.addressForm.controls.AddressLine3.value,
            State: decryptData.State ? decryptData.State : this.addressForm.controls.State.value,
            City: decryptData.City ? decryptData.City : this.addressForm.controls.City.value,
            PinCode: decryptData.Pincode ? decryptData.Pincode : this.addressForm.controls.PinCode.value,
          })
        }
      },
      error: e => {
        this.loader.stop();
        this.errorComp.ModalShow(e.error.Message);
      }
    })
  }
  stageValidate() {
    const url = "DIY/DIYUpdtPerAddr";
    let params: any = '';
    const checkSum = this.erefNo;
    let error = 0;
    if (this.NRO === 'Y' && !this.MobileLinkAadhar) {
      this.errorComp.ModalShow('Please select mobile link aadhar');
      // this.toastr.error('Please upload address proof front image');
      error++;
      return;
    }
    if (!this.perAdrUpdt && !this.previousDocs && this.mandatory) {
      this.perAdrImgempty = true;
      this.errorComp.ModalShow('Please upload address proof front image');
      // this.toastr.error('Please upload address proof front image');
      error++;
    }
    else if (!this.perAdrUpdt1 && !this.previousDocs && this.mandatory && !this.digi) {
      this.perAdrImgempty1 = true;
      this.errorComp.ModalShow('Please upload address proof back image');
      // this.toastr.error('Please upload address proof back image');
      error++;
    }
    else if (!this.addressForm.controls.PinCode.value && this.mandatory) {
      this.pincodeErrorMsg = true;
      this.errorComp.ModalShow('Please Enter Pincode');
      // this.toastr.error('Please Enter Pincode');
      error++;
    }
    else if (!this.addressForm.controls.City.value && this.mandatory) {
      this.cityNameError = true;
      this.errorComp.ModalShow('Please Enter City');
      // this.toastr.error('Please Enter City');
      error++;
    }
    else if (!this.addressForm.controls.State.value && this.mandatory) {

      this.stateErrorMsg = true;
      this.errorComp.ModalShow('Please Enter State');
      // this.toastr.error('Please Enter State');
      error++;
    }
    else if (!this.docNumberValue && this.mandatory) {

      this.stateErrorMsg = true;
      this.errorComp.ModalShow('Please Enter Address Proof Number.');
      // this.toastr.error('Please Enter State');
      error++;
    }
    else if (!this.lastArrivalDate && this.datesection && this.mandatory) {
      this.errorComp.ModalShow('Please enter your Expiry Date');
      return;
    }
    else if (this.addressForm.valid || !this.mandatory || this.digi) {

      params = {
        "ReferenceNumber": this.erefNo,
        "IsIndianPassport": false,
        "IsPassport": false,
        "AddressLine1": this.addressForm.controls.AddressLine1.value,
        "AddressLine2": this.addressForm.controls.AddressLine2.value,
        "AddressLine3": this.addressForm.controls.AddressLine3.value,
        "City": this.addressForm.controls.City.value,
        "State": this.addressForm.controls.State.value,
        "Pincode": this.addressForm.controls.PinCode.value,
        "Country": this.addressForm.controls.Country.value,
        "CommunicationAddress": this.communicationAddress,
        "DocumentId": this.addressForm.controls.DocType.value,
        'PER_ADD_REF': this.docNumberValue,
        'MobileLinkAadhar': this.MobileLinkAadhar,
        "PEXDATE": this.lastArrivalDate,
      }
    }
    if (error === 0) {
      this.loader.start();
      this._http.httpPost(url, params, checkSum).subscribe({
        next: (data: any) => {
          this.loader.stop();
          let val = this.http.decryptUsingAES256(data.OutPut)
          if (val && val.IsSuccess) {
            sessionStorage.removeItem('searchParams');
            if (this.pioletter === 'F') {
              this.router.navigate(['/fatca'], { replaceUrl: true });
            } else {
              // this.toastr.success(val.Success);
              this.router.navigate(['/visa'], { replaceUrl: true });
            }

          } else {
            this.errorComp.ModalShow("Please try again.");
            // this.toastr.error("Please try again.");
          }
        },
        error: error => {
          this.loader.stop();
          if (!window.navigator.onLine) {
            this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.")
            // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
          } else {
            this.errorComp.ModalShow(error.error.Message)
            // this.toastr.error(error.error.Message)
          }
        }
      });
    }
  }

  checkPin() {
    if (this.pinCode.length === 6 || (this.pinCode.Pincode && this.pinCode.Pincode.length === 6)) {
      this.getPinCodeVal();
    } else {
      this.pinCodeError = true;
    }
  }

  checkCity() {
    let c = '';
    if (this.cityName.City) {
      c = this.cityName.City;
    } else {
      c = this.cityName;
    }

    c = c.toUpperCase();

    let city = this.cityList.filter((e: any) => {
      return e.City === c
    })
    if (!city || city.length === 0) {
      this.cityNameError = true;
    } else {
      this.cityNameError = false;
      this.addressForm.controls.City.setValue(c);
    }
  }
  digiInvoke(proceed: boolean) {
    // if (!proceed) {
    //   this.digiModal.hide();
    //   return;
    // }
    const checkSum = this.erefNo;
    this.loader.start();
    const URL = 'DIY/GetDigiLockerUrl';
    let payload = {
      "ReferernceNumber": this.erefNo,
      // "Mobile": this.sessionMob,
      // "ClientName": this.firstName,
      // "CallBackUrl": location.href
    }
    this._http.httpPost(URL, payload, checkSum).subscribe({

      next: (data: any) => {
        // this.loader.stop();
        let val = this.http.decryptUsingAES256(data.OutPut)
        if (val?.IsSuccess) {
          console.log(val);
          if (val['DigiLockUrl']) {
            location.assign(val['DigiLockUrl']);
          }
          // else {
          //   this.digio_doc_id = data['digio_doc_id'];
          //   this.digilockerFetch();
          // }
        } else {
          this.toastr.error(val.message || 'Please try again later.')
        }
      }, error: e => {
        this.loader.stop();
      }
    })
  }

  digilockerFetch() {
    this.loader.start('FetchDigiLockerInfo');
    const URL = 'DIY/FetchDigiLockerInfo';
    const checkSum = this.erefNo;
    // this.panIdNumber = sessionStorage.getItem("pan") || '';
    // const decryptedPan: string = this.http.decryptUsingAES256(this.panIdNumber);
    let payload = {
      "ReferernceNumber": this.erefNo,
      "Token": this.digio_doc_id,
      // "status": this.DigiStatus,
      "PanClientName": this.ClientName,
      "Pannumber": this.pan
    }
    this._http.httpPost(URL, payload, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop('FetchDigiLockerInfo');
        let val = this.http.decryptUsingAES256(data.OutPut)
        if (val?.IsSuccess) {
          this.toastr.success(val.SuccessMessage);
          this.MobileLinkAadhar = 'Y';
          this.DigiOptionval = 'Y';
          // this.coressdAddress = true;
          sessionStorage.setItem("digilocker", 'Y')
          // Address Line 1
          let addressLine1 = '';
          if (!val.PoaHouseNo && val.PoaCO) {
            addressLine1 = val.PoaCO;
          } else if (val.PoaHouseNo && !val.PoaCO) {
            addressLine1 = val.PoaHouseNo;
          } else if (val.PoaHouseNo && val.PoaCO) {
            addressLine1 = val.PoaCO + ', ' + val.PoaHouseNo;
          }
          if (!addressLine1 && val.PoaVillage) {
            addressLine1 = val.PoaVillage;
          }

          // Address Line 2
          let addressLine2 = '';
          if (val.PoaStreet) {
            addressLine2 = val.PoaStreet;
          } else if (!val.PoaStreet && val.PoaLocation) {
            addressLine2 = val.PoaLocation;
          }
          if (!addressLine2 && val.PoaDistrict) {
            addressLine2 = val.PoaDistrict;
          }

          // Address Line 3
          let addressLine3 = '';
          if (val.PoaVillage) {
            addressLine3 = val.PoaVillage;
          }
          if (!addressLine3 && val.PoaDistrict) {
            addressLine3 = val.PoaDistrict;
          }

          this.addressForm.patchValue({
            "AddressLine1": addressLine1,
            "AddressLine2": addressLine2,
            "AddressLine3": addressLine3,
            "PinCode": val.PoaPinCode,
            "State": val.PoaState,
            "City": val.PoaDistrict,
            "Country": val.PoaCountry,
            // "DocNumber": val.UID.slice(-4),
          });
          this.docNumberValue = val.UID.slice(-4);
          this.digi = true;
          this.permanentoption = true;
          this.docTypeCheck(11, false);
          let vale = 11
          this.addressForm.controls.DocType.setValue(vale)

          // if (data.digiLockerInfo?.panGender.toUpperCase() === "M") {
          //   this.passportForm.controls.Gender.setValue('M');
          //   this.title = "MR";
          // } else if (data.digiLockerInfo?.panGender.toUpperCase() === "F") {
          //   this.passportForm.controls.Gender.setValue('F');
          //   this.title = "MS";
          // } else if (data.digiLockerInfo?.panGender.toUpperCase() === "O") {
          //   this.passportForm.controls.Gender.setValue('O');
          //   this.title = "MR";
          // }
          this.addressForm.disable();
          var digiImgUrl = "DIY/UploadDigiProof"
          var digiImgsendData = {
            "ReferernceNumber": this.erefNo,
            "Type": 'D'
          }
          this.loader.start('UploadDigiProof');
          this._http.httpPost(digiImgUrl, digiImgsendData, checkSum).subscribe({
            next: (data: any) => {
              this.loader.stop('UploadDigiProof');
              this.fileUploadComp.getImages();
            }
          })
        }
        else {
          this.loader.stop('FetchDigiLockerInfo');
          this.toastr.error(val?.ErrorMessage)
        }
      }, error: e => {
        this.loader.stop('FetchDigiLockerInfo');
      }
    })
  }

  DigiOption(value: string) {
    if (value === 'Y') {
      this.digiInvoke(true)
    } else {
      this.MobileLinkAadhar = 'N';
      this.permanentoption = true;
    }
  }

  backStage() {
    this.router.navigate(['/foreign-address'], { replaceUrl: true });
  }

  onDateArrival(event: any) {
    this.ExpiryDate = '';
    this.lastArrivalDate = event.formatted;

    // Convert the selected date to a proper Date object
    let e = this.lastArrivalDate.split('/');
    let formattedDate = `${e[2]}-${e[1]}-${e[0]}`;
    let selectedDate = new Date(formattedDate);

    // Get the current date and calculate the date 60 days ago
    let today = new Date();
    let sixtyDaysAgo = new Date(today.setDate(today.getDate() - 60));

    // Check if the selected date is more than 60 days before today
    if (selectedDate.getTime() < sixtyDaysAgo.getTime()) {
      this.arrivalDateError = true;
    } else {
      this.arrivalDateError = false;
    }
  }
}
